import React from "react";
import Header from "./Header";
import ExtensionHub from "../extension/ExtensionHub";

export default function LayoutExtensionHub() {
  return (
    <>
      <Header />
      <ExtensionHub />
    </>
  );
}
